import { c as _c } from "react/compiler-runtime";
import { FunnelTabCard } from 'modules/funnels/funnel/components/funnel-tab-card';
import { type JSX } from 'react';
function DeadlineSettingsItemLayout(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <FunnelTabCard className="flex flex-col gap-4">{children}</FunnelTabCard>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default DeadlineSettingsItemLayout;